import { ofType } from 'redux-observable';
import { concat, of } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';

import { SEARCH_AUTOCOMPLETE_ENDPOINT_URL } from '../../../common/constants/request';

import logger from '../../../common/helpers/logger';
import { tmPostRequest } from '../../../common/helpers/request';
import * as commonSelectors from '../../../common/redux/selectors/common';
import {
  autocompleteRequestAction,
  clearAutocompleteAction,
  errorAutocompleteAction,
  setAutocompleteAction,
  setAutocompletePreloaderAction,
} from '../slices/autocomplete';

export default (action$, state$) =>
  action$.pipe(
    ofType(autocompleteRequestAction.type),
    switchMap(({ payload: value }) => {
      const watchId = commonSelectors.idSelector(state$.value);

      const stream$ = tmPostRequest({
        url: SEARCH_AUTOCOMPLETE_ENDPOINT_URL,
        body: {
          inquiry: value,
          vhId: watchId,
        },
      }).pipe(
        switchMap(({ status, response }) => {
          const payload = status === 200 ? Array.from(new Set(response.hits.map((item$) => item$.inquiry))) : [];

          return concat(of(setAutocompleteAction(payload)));
        }),
        catchError((error) => {
          logger.error(
            'Error of autocomplete request',
            'src/modules/Search/redux/epics/autocomplete.js',
            SEARCH_AUTOCOMPLETE_ENDPOINT_URL,
            error,
          );

          return of(errorAutocompleteAction());
        }),
      );

      return concat(of(setAutocompletePreloaderAction(true)), of(clearAutocompleteAction()), stream$);
    }),
  );
